export function Legend() {
  return (
    <div className="absolute bottom-4 right-4 z-20 w-64 rounded-md border border-white/15 bg-black/65 p-3 text-sm backdrop-blur">
      <p className="font-medium">Pressure index</p>
      <div className="mt-3 h-2 rounded-full bg-gradient-to-r from-emerald-400 via-amber-300 to-red-500" />
      <div className="mt-2 flex justify-between text-xs text-muted-foreground">
        <span>stable</span>
        <span>watch</span>
        <span>critical</span>
      </div>
      <div className="mt-3 flex items-center gap-2 text-xs text-muted-foreground">
        <span className="relative h-3 w-3 rounded-full bg-red-400">
          <span className="absolute inset-0 animate-ping rounded-full bg-red-400/70" />
        </span>
        pulsing markers indicate high-pressure regions
      </div>
    </div>
  );
}
